import { AssetFieldModel } from "./asset_field.model";
import { AssetPresetFieldsModel } from "./asset_preset_fields.model";
import { AssetPresetStlModel } from "./asset_preset_stl.model";
import { FilterModel } from "./filter.model";

export class AssetTypeModel {

  assetTypeUid: number;
  assetTypeName: string;
  assetTypeIcon: string;
  requireConditionReport: boolean;
  description: string;
  fields: Array<AssetFieldModel> = [];
  allFieldValuePresets: Array<AssetPresetFieldsModel> = [];
  allStlPresets: Array<AssetPresetStlModel> = [];
  isStreetLight: boolean;
  organisationUid: number;
  presetName: string;

  groupSelect: FilterModel;
  groupUid: number;
  groupName: string;
  
  constructor() {

  }
}